<!-- just backgroundWrapper -->
<div class="header md:h-[240px] h-[130px]"></div>

<img [src]="cdnUrl + '/images/webengage/img9.png'" class="md:-mt-[14rem] -mt-[100px] z-10 relative">

<div class="content pt-2 px-5 text-center">
    <!-- shomal -->
    <p *ngIf="data == 'shomal'" class="font-bold my-5 text-2xl">
        شما را به یک سفر رویایی به شمال دعوت می‌کنیم!
    </p>
    <p *ngIf="data == 'shomal'" class="pb-3">
        با کلیک بر روی این دکمه، از تخفیف‌های ویژه و قیمت‌های استثنایی ما بهره‌مند شوید.
    </p>
    <!-- jonoob -->
    <p *ngIf="data == 'jonoob'" class="font-bold my-5 text-2xl">
        آیا برای یک ماجراجویی ساحلی آماده‌اید؟
    </p>
    <p *ngIf="data == 'jonoob'" class="pb-3">
        جهت دریافت قیمت‌های باور نکردنی برای سفر به کیش و قشم شماره همراه خود را وارد کنید.
    </p>
    <!-- webengage -->
    <p *ngIf="data == 'webengage'" class="font-bold my-5 text-2xl">
        بهانه‌ای برای سفری معنوی به حرم عشق
    </p>
    <p *ngIf="data == 'webengage'" class="pb-3">
        جهت دریافت کد تخفیف 400 هزار تومانی رزرو هتل های مشهد شماره موبایل خود را وارد کنید.
    </p>
    <!-- safarmarket.ir -->
    <p *ngIf="['safarmarket.ir','ads.google.com','kojaro.com','seeiran.ir','varzesh3.com','BankSaman'].includes(data)"
        class="font-bold my-5 text-2xl">رزرو هتل در سراسر
        کشور، به صرفه تر از همیشه!</p>
    <p *ngIf="['safarmarket.ir','ads.google.com','kojaro.com','seeiran.ir','varzesh3.com','BankSaman'].includes(data)" class="pb-3">
        جهت دریافت کد های تخفیف ویژه لطفا شماره
        همراه خود را وارد کنید و از سفرهای ارزانتر لذت برید</p>
    <!-- 'yektanet3.com -->
    <p *ngIf="data == 'yektanet3.com'" class="font-bold my-5 text-2xl">بهانه‌ای برای سفری معنوی به حرم عشق</p>
    <p *ngIf="data == 'yektanet3.com'" class="pb-3">جهت دریافت کد تخفیف 3 شب اقامت هتل های مشهد شماره موبایل خود را وارد
        کنید</p>


    <p class="font-bold my-5 text-2xl" *ngIf="['yektanet2.com'].includes(data)">
        تخفیف 200 هزار تومانی سفر به اصفهان دل انگیز
    </p>
    <p *ngIf="!['yektanet1.com',
    'yektanet2.com',
    'safarmarket.ir',
    'yektanet.com',
    'BankSaman',
    'yektanet3.com',
    'ads.google.com',
    'varzesh3.com',
    'shomal',
    'jonoob',
    'webengage',
    'kojaro.com',
    'seeiran.ir'].includes(data)" class="font-bold my-5 text-2xl">300 هزار
        تومان تخفیف
        بهاری</p>
    <p *ngIf="['yektanet1.com'].includes(data)" class="font-bold my-5 text-2xl">
        تخفیف یک میلیون تومانی سفر به شمال
    </p>
    <p *ngIf="['yektanet.com'].includes(data)" class="font-bold my-5 text-2xl">
    350 هزار تومان تخفیف تابستانی
    </p>
    <p class="font-bold my-5 text-2xl" *ngIf="['yektanet'].includes(data)">
        تخفیف 200 هزار تومانی سفر به شیراز زیبا
    </p>
    <p class="pb-3"
        *ngIf="!['safarmarket.ir','yektanet3.com','ads.google.com',
        'shomal','jonoob','webengage','BankSaman','seeiran.ir','kojaro.com','varzesh3.com'].includes(data)">
        جهت دریافت کد تخفیف شماره موبایل خود را وارد کنید.
    </p>
    <div class="w-[250px] m-auto">
        <form class="text-start mx-auto d-block" action="#" method="post" autocomplete="off" novalidate="">
            <mat-form-field appearance="outline" class="w-full density-settings-0 mt-5">
                <mat-label class="!text-lg">شماره موبایل</mat-label>
                <input matInput class="!font-bold" type="tel" [formControl]="phoneNumber">
            </mat-form-field>

            <button type="submit" (click)="letMeKnow()"
                class="w-full h-[52px] bg-yellow-400 rounded-lg font-bold mt-3 mb-8">
                <ng-container *ngIf="!loading;else showLoading">
                    دریافت کد تخفیف
                </ng-container>

                <ng-template #showLoading>
                    <div class="typing-animation m-auto">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </ng-template>
            </button>
        </form>
    </div>
</div>